export default __webpack_public_path__ + "static/media/header.b3e3c5c5.png";